import { External, M } from '../external';

export const DAY = 24 * 60 * 60 * 1000;
export const TIMEZONE_OFFSET = new Date().getTimezoneOffset() * 60 * 1000;

export const months = [M.JANUARY, M.FEBRUARY, M.MARCH, M.APRIL, M.MAY, M.JUNE, M.JULY, M.AUGUST, M.SEPTEMBER, M.OCTOBER, M.NOVEMBER, M.DECEMBER];
export const monthsShort = [M.JAN, M.FEB, M.MAR, M.APR, M.MAY_SHORT, M.JUN, M.JUL, M.AUG, M.SEP, M.OCT, M.NOV, M.DEC];

export function ignore() {
}

export function resource(path) {
  return External.resources + path + '?v=' + External.resourcesVersion;
}

export function currencyToStr(amount) {
  if (amount === undefined || amount === '') {
    return '';
  }
  let symbol = External.Website.storeCurrencySymbol;
  let symbolAtLeft = External.Website.storeCurrencyPositionAtLeft;
  if (symbolAtLeft) {
    return symbol + amount.toFixed(2);
  } else {
    return amount.toFixed(2) + symbol;
  }
}

export function copy(text) {
  External.Tools.copyToClipboard(text);
  External.Tools.showCornerMessage(1000, M.COPIED_TO_CLIPBOARD, External.Tools.TOOLTIP_TYPE_SUCCESS);
}

export function makeWebsiteRequest(options, rejectOnError) {
  options = options || {};
  return new Promise((resolve, reject) => {
    options.onOk = resolve;
    options.onNotOk = rejectOnError ? reject : resolve;
    External.Tools.makeWebsiteRequest(options);
  });
}

export function makeClientWebsiteRequest(options) {
  options = options || {};
  return new Promise(function(resolve, reject) {
    options.onOk = resolve;
    options.onNotOk = reject;
    External.WebPlatform.makeClientWebsiteRequest(options);
  });
}

export function styleParser(style, skip = []) {
  if (!style) {
    return '';
  }

  let arr = [];
  for (let key in style) {
    if (style.hasOwnProperty(key) && skip.indexOf(key) === -1) {
      arr.push(
        key
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .replace(/[_\s]/, '-')
        .toLowerCase() +
        ':' +
        style[key]
      );
    }
  }

  return arr.join(';');
}

export function getStyleValue(val, defaultValue) {
  if (!val) {
    return defaultValue;
  }
  val = '' + val;
  return val.replace('px', '').replace('%', '');
}

export function array_move(arr, old_index, new_index) {
  if (new_index >= arr.length) {
    let k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr;
}

export function randomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

export function imageUrl(data, defaultValue = '') {
  if (data.base && data.file) {
    return External.getFileFromBase(data.base) + data.file;
  }
  return defaultValue;
}

export function invertColor(hex, bw) {
  if (hex === 'transparent') hex = '#ffffff';
  if (hex.indexOf('#') === 0) {
    hex = hex.slice(1);
  }
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
    throw new Error('Invalid HEX color.');
  }
  let r = parseInt(hex.slice(0, 2), 16),
    g = parseInt(hex.slice(2, 4), 16),
    b = parseInt(hex.slice(4, 6), 16);
  if (bw) {
    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
  }
  r = (255 - r).toString(16);
  g = (255 - g).toString(16);
  b = (255 - b).toString(16);

  return '#' + padZero(r) + padZero(g) + padZero(b);
}

function padZero(str, len) {
  len = len || 2;
  const zeros = new Array(len).join('0');
  return (zeros + str).slice(-len);
}

export function generateSocialIcon(data, idx) {
  const postfix = data.menuTheme === 'dark' ? '-b' : '';
  return External.resources + '/images/marketing/icons/' + data.menu[idx].type + postfix + '.png';
}

export function getCollapseClass(isCollapsable, isCollapsed) {
  if (!isCollapsable) {
    return 'email-styling-separation-line';
  }
  return isCollapsed ? 'email-styling-separation-collapse' : 'email-styling-separation';
}

export function getRandomInt() {
  return Math.round(Math.random() * 100000);
}

export function getNextId(data) {
  if (!data || data.length === 0) {
    return getRandomInt();
  }

  const takenIds = [];
  let id = getRandomInt();

  data.forEach(function(row) {
    takenIds.push(row.id);
  });

  while (takenIds.indexOf(id) !== -1) {
    id = getRandomInt();
  }

  return id;
}

export function parseNumber(value) {
  let number = Number(value);
  return isNaN(number) ? 0 : number.toLocaleString();
}

export function parsePercent(val) {
  const n = Number((Number(val) * 100).toPrecision(3));
  return !isNaN(n) ? (isFinite(n) ? n : '∞') + '%' : '0.00%';
}

export function calcPercent(part, fromAll) {
  let val = fromAll ? part / fromAll : 0;

  return parsePercent(val);
}

let checkValid = function(data) {
  return data && data.stats;
};

export function showIntValue(data, key) {
  if (!checkValid(data)) {
    return 0;
  }

  return parseNumber(data.stats[key]);
}

export function showPercentValue(data, key) {
  if (!checkValid(data)) {
    return '0.00%';
  }

  return parsePercent(data.stats[key]);
}

/**
 * Deep clone primitive types, do not use Dates, functions, undefined, Infinity, RegExps, Maps, Sets, Blobs, FileLists,
 * ImageDatas, sparse Arrays, Typed Arrays or other complex types.
 * @param obj object/array to be cloned
 * @returns {any} cloned object/array
 */
export function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export function screenshot(options) {
  options = options || {};
  let dimensions = options.dimensions ? options.dimensions.toString().replace('px', '') : '700';

  if (parseInt(dimensions) < 700) {
    dimensions = '700';
  }

  let params = '?screenshot=1';
  let filename = 'screenshot';
  if (options.emailName) {
    params += '&name=' + options.emailName;
    if (options.isTemplate) {
      params += '&is_template=true';
    }
    if (options.isSystem) {
      params += '&is_system=true';
    }
    filename = options.emailName;
  } else if (options.campaignId) {
    params += '&id=' + options.campaignId;
    filename = options.campaignId;
  } else if (options.automationId) {
    params += '&id=' + options.automationId + '&stepId=' + (options.stepId || '');
    filename = options.automationId + '_' + options.stepId;
  }

  let iframe = document.createElement('iframe');

  function receiveMessage(event) {
    if (!event || !event.data || event.data.type !== 'screenshot') return;
    //cleanup
    window.removeEventListener('message', receiveMessage);
    document.body.removeChild(iframe);
    iframe = null;

    let blob = new File([event.data.blob], filename + '.png', { type: 'image/png' });

    External.Tools.makeWebsiteRequestWithFile(
      {
        action: 'uploadTemplateScreenshot',
        method: 'post',
        data: {
          template: filename
        },
        onOk: function() {
          if (options.onReady) options.onReady(filename);
        }
      },
      blob
    );
  }

  let iframeSrc = 'https://' + (External.subdomain === 'www' ? '' : External.subdomain + '.') + External.domain + '/me/email' + params;
  let iframeId = 'iframe' + getRandomInt();
  iframe.src = options.content ? 'about:blank' : iframeSrc;
  iframe.width = iframe.height = dimensions;
  iframe.style.opacity = '0';
  iframe.style.position = 'absolute';
  iframe.style.zIndex = -1;
  iframe.id = iframeId;
  iframe.name = iframeId;

  window.addEventListener('message', receiveMessage, false);
  document.body.appendChild(iframe);

  if (options.content) {
    let form = External.$('<form class="none" action="' + iframeSrc + '" method="post" target="' + iframeId + '"></form>');
    let input = External.$('<input type="hidden" name="content" />');
    input.val(JSON.stringify(options.content));
    form.append(input);
    External.$('body').append(form);
    form.submit();
    form.remove();
    form = null;
  }
}

export function getProperty(list, property, value) {
  if (list == null || list.length === 0) {
    return null;
  }

  for (let i = 0; i < list.length; i++) {
    if (list[i][property] === value) {
      return list[i];
    }
  }

  return null;
}

export function filterToString(filter) {
  let property = External.Tools.getPropertyByFilter(filter);
  if (!filter.func) return '';

  let func = External.CRM_FILTER_FUNCTION_NAMES[filter.func];
  let value = '...';
  let suffix = '';

  let isWithoutValue = filter.func === 'any' || filter.func === 'unknown';

  if (isWithoutValue || filter.func === 'isTrue' || filter.func === 'isFalse') value = '';
  else if (filter.value) value = filter.value;

  if (filter.value && property && property.type === External.CRM_PROPERTY_TYPE.COUNTRY) {
    value = External.COUNTRIES[External.COUNTRY_CODES.indexOf(filter.value)] || filter.value;
  }

  let isDaysAgo = filter.func === 'moreThan' || filter.func === 'exactly' || filter.func === 'lessThan';
  if (value && value !== '...' && isDaysAgo) suffix = M.CRM_DAYS_AGO_RIGHT;

  if (filter.value && property && property.type === External.CRM_PROPERTY_TYPE.DATE && !isWithoutValue && !isDaysAgo) {
    value = External.Tools.dateToShortString(new Date(+filter.value), true, true);
  }

  let label = '';
  if (property) {
    label = property.label;
  } else {
    label = filter.type === External.CRM_FILTER_TYPE.SUBSCRIBER_LIST ? M.SUBSCRIBER_LIST : M.VALUE;
  }

  label += ' ' + func;
  if (value) label += ' ' + value;
  if (suffix) label += ' ' + suffix;
  return label;
}

export function generateCanvasGradient(canvas, colors) {
  let gradient = canvas.getContext('2d').createLinearGradient(0, 0, 0, 150);
  for (let idx = 0; idx < colors.length; ++idx) {
    let step = (1.0 / (colors.length - 1)) * idx;
    gradient.addColorStop(step, colors[idx]);
  }
  return gradient;
}

export async function getStoreCategories(parentId) {
  let result = await makeWebsiteRequest({
    action: 'getStoreCategories',
    data: {
      parent: parentId
    }
  });

  let categories = result.data;
  return categories || [];
}

export function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

export function throttle(callback, limit) {
  let waiting = false; // Initially, we're not waiting
  return function() {
    // We return a throttled function
    if (!waiting) {
      // If we're not waiting
      callback.apply(this, arguments); // Execute users function
      waiting = true; // Prevent future invocations
      setTimeout(function() {
        // After a period of time
        waiting = false; // And allow future invocations
      }, limit);
    }
  };
}

export let withTax = (value, taxRate) => value * (100 + taxRate) / 100;

export let formatMoney = (value, currency, decorator, noZeroes) => {
  if (decorator === true) {
    decorator = (curr) => `<span class="price-table-sign">${curr}</span>`;
  }
  let result = External.WebPlatform.currencyWithCodeToStr(value, currency, decorator, External.platformCountry);
  if (noZeroes && result.indexOf('.00') > -1) {
    result = result.replace('.00', '');
  }
  return result;
};

export function calcGroupingForTimeRange(minimumPeriodTime, periodStart, periodEnd) {
  let startTime = periodStart || new Date(minimumPeriodTime);
  let endTime = periodEnd || new Date();
  startTime.setHours(0, 0, 0, 0);
  endTime.setHours(23, 59, 59, 999);
  let diff = Math.abs(endTime.getTime() - startTime.getTime());
  if (diff < 2 * DAY) {
    return 'hourly';
  } else if (diff <= 31 * DAY) {
    return 'daily';
  } else if (diff < 558 * DAY) {
    // 18 months
    return 'monthly';
  } else {
    return 'yearly';
  }
}

const platformVars = ['platform_name', 'platform_domain'/*, 'platform_logo'*/];
const websiteVars = ['website_name', 'website_url'];

/**
 * Returns an array of objects with tags available for each email template; together with a flag if crmProperties are allowed for the specified template
 * @param key template name
 * @returns {*}
 */
export function variableDictionary(key) {
  return {
    // these are not really used yet
    new_payment: ['website', 'plan', 'billing-cycle', 'amount', 'transaction', ...platformVars],
    site_canceled: ['website', ...platformVars],
    data_request: ['user_name', 'user_email', 'type', 'customerEmail', 'customerWebsite', ...platformVars],
    reseller_new_team_member_registration: ['logo', 'name', 'resellerName', 'link', ...platformVars],
    reseller_new_team_member: ['logo', 'name', 'resellerName', 'domain', ...platformVars],
    reseller_payment_reminder: ['date', 'price', 'domain', ...platformVars],
    reseller_payment_result: ['status', 'message', 'productTitle', 'subtotal', 'tax', 'total', 'actionButtonLink', 'actionButtonText', ...platformVars],
    affiliate_payout_request: ['logo', 'name', 'email', 'amount', 'domain', ...platformVars],
    affiliate_new_registration: ['logo', 'name', 'email', 'domain', ...platformVars],
    reseller_new_registration: ['logo', 'name', 'email', 'domain', ...platformVars],
    failed_webhook: ['websiteTitle', 'target', 'event', 'response', 'body', 'url', ...platformVars],
    empty: ['data', ...platformVars],
    // these are used, sent to customers (contacts)
    booking_client_notification: {
      hasCrmTags: true,
      tags: ['event_name', 'operator', 'date_time', 'time_zone', 'duration', 'description', 'location', 'meeting_link', 'cancel_booking_url', ...websiteVars]
    },
    booking_client_reminder: {
      hasCrmTags: true,
      tags: ['event_name', 'operator', 'date_time', 'time_zone', 'duration', 'description', 'location', 'meeting_link', 'cancel_booking_url', ...websiteVars]
    },
    booking_cancelled_notification: {
      hasCrmTags: true,
      tags: ['event_name', 'operator', 'date_time', 'duration', 'description', 'location', 'participant_name', ...websiteVars]
    },
    digital_goods_download_email: {
      hasCrmTags: true, tags: ['order_title', ...websiteVars]
    },
    list_subscription_double_opt_in: {
      hasCrmTags: true,
      tags: ['contact_email', 'confirm_subscription_url', ...websiteVars]
    },
    members_email: {
      hasCrmTags: true,
      tags: ['member_name', ...websiteVars]
    },
    new_order_cancelled: {
      hasCrmTags: true,
      tags: [
        'invoice_no', 'invoice_date', 'order_total',
        'order_status_description', 'shipping_address', 'billing_address', 'payment_instructions', 'cod_fee', ...websiteVars]
    },
    new_order_completed: {
      hasCrmTags: true,
      tags: [
        'invoice_no', 'invoice_date', 'order_total',
        'order_status_description', 'shipping_address', 'billing_address', 'payment_instructions', 'cod_fee', ...websiteVars]
    },
    new_order_pending: {
      hasCrmTags: true,
      tags: ['order_title', 'invoice_no', 'invoice_date', 'order_total',
        'order_status_description', 'shipping_address', 'billing_address', 'payment_instructions', 'cod_fee', ...websiteVars]
    },
    new_order_shipped: {
      hasCrmTags: true,
      tags: ['invoice_no', 'invoice_date', 'order_total',
        'order_status_description', 'shipping_address', 'billing_address', 'payment_instructions', 'cod_fee',
        'tracking_no', 'tracking_url', ...websiteVars]
    },
    password_recovery: {
      hasCrmTags: true,
      tags: ['reset_password_url', ...websiteVars]
    },
    store_subscription_failed: {
      hasCrmTags: true,
      tags: ['member_name', 'error', 'order_total', 'update_billing_url', ...websiteVars]
    },
    // these are used, sent to admins
    blog_comment_admin: {
      hasCrmTags: false,
      tags: ['user', 'post_name', 'comment', 'view_post_url', ...websiteVars, ...platformVars]
    },
    booking_notification_admin: {
      hasCrmTags: false,
      tags: ['event_name', 'operator', 'date_time', 'duration', 'description', 'location', 'meeting_link', 'answers', 'cancel_booking_url', 'view_bookings_url', ...websiteVars, ...platformVars]
    },
    booking_cancelled_notification_admin: {
      hasCrmTags: false,
      tags: ['event_name', 'operator', 'date_time', 'duration', 'description', 'location', 'participant_name', 'participant_email', 'view_bookings_url', ...websiteVars, ...platformVars]
    },
    member_registration_admin: {
      hasCrmTags: false,
      tags: ['member_name', 'member_email', 'crm_url', ...websiteVars, ...platformVars]
    },
    new_form_message_admin: {
      hasCrmTags: false,
      tags: ['form_name', 'message', 'view_message_url', ...websiteVars, ...platformVars]
    },
    new_order_admin: {
      hasCrmTags: false,
      tags: ['order_title', 'invoice_no', 'invoice_date', 'order_total',
        'order_status_description', 'shipping_address', 'billing_address', 'payment_instructions', ...websiteVars, ...platformVars]
    },
    store_subscription_cancelled_admin: {
      hasCrmTags: false,
      tags: ['member_name', 'member_email', 'view_profile_url', ...websiteVars, ...platformVars]
    },
    store_subscription_failed_admin: {
      hasCrmTags: false,
      tags: ['member_name', 'member_email', 'error', 'order_total', 'crm_url', ...websiteVars, ...platformVars]
    },
    whatsapp_template_approved_admin: {
      hasCrmTags: false,
      tags: ['template_name', 'template_status', 'template_url', 'template_rejection_reason', ...websiteVars, ...platformVars]
    },
    whatsapp_template_rejected_admin: {
      hasCrmTags: false,
      tags: ['template_name', 'template_status', 'template_url', 'template_rejection_reason', ...websiteVars, ...platformVars]
    },
    whatsapp_template_paused_admin: {
      hasCrmTags: false,
      tags: ['template_name', 'template_status', 'template_url', 'template_rejection_reason', ...websiteVars, ...platformVars]
    },
    whatsapp_template_disabled_admin: {
      hasCrmTags: false,
      tags: ['template_name', 'template_status', 'template_url', 'template_rejection_reason', ...websiteVars, ...platformVars]
    },
    contact_message_received_admin: {
      hasCrmTags: false,
      tags: ['member_name', 'message', ...websiteVars, ...platformVars]
    },
    unread_community_mention: {
      hasCrmTags: false,
      tags: ['notification_summary', 'comment_content', 'author_name', ...websiteVars, ...platformVars]
    },
    unread_community_reply: {
      hasCrmTags: false,
      tags: ['notification_summary', 'reply_content', 'author_name', ...websiteVars, ...platformVars]
    },
    member_circle_access_approved: {
      hasCrmTags: true,
      tags: ['member_name', 'circle_name', 'circle_url', ...websiteVars]
    }
  }[key];
}

export function millisecondsToTimestamp(milliseconds) {
  if (!milliseconds || milliseconds === 0) {
    return '00:00.00';
  }
  let minutes = Math.floor(milliseconds / 1000 / 60);
  let seconds = (milliseconds / 1000 - minutes * 60).toFixed(2);
  return minutes.toString().padStart(2, '0') + ':' + seconds.padStart(5, '0');
}


export function splitDateStringToDateTimeParts(dateStr) {
  if (!dateStr) {
    return {
      date: '',
      time: ''
    };
  }

  let date = External.WebsiteSettings.getDateFormat() === 'uk' ? External.WebPlatform.ukDateTimeStringToDate(dateStr) : External.WebPlatform.usDateTimeStringToDate(dateStr);
  return {
    date: External.WebPlatform.dateToStrWithMonth(date, false, true),
    time: dateStr.substr(dateStr.indexOf(' ') + 1)
  };
}
